export interface BadgeLocale {
  lang: string;
  country: string;
}

/**
 * Derives the language/country for the AI badge from the document locale.
 * `layout/default.peb` renders `<html lang="{{ ENV.LANGUAGE_CODE }}">` (e.g. `de-DE`),
 * so `document.documentElement.lang` is the single reliable client-side source.
 */
export const getBadgeLocale = (): BadgeLocale => {
  const locale = (document.documentElement.lang || 'de-DE').toLowerCase();
  const [lang = 'de', country = 'de'] = locale.split('-');
  return { lang, country };
};
